const customView = state => state.customView;

export default customView;
